<template>
<div class="page">
   <h-header title="课程列表" :back="true" btnText="编辑" 
    @btnFuc="showCreate" 
    @loginSuccess="loginSuccess">
   </h-header>
   <div class="main-show">
       <div class="show">
        <div class="content">
            <div class="left">
                <div class="img-default" v-if="!obj.img">
                    <div class="title">{{obj.title}}</div>
                </div>
                <div class="img-box" v-else>
                    <img :src="splitUrl(obj.img)">
                </div>
            </div>
            <div class="right">
                <div class="top">
                    <span>{{judgeStatusShow(obj.status,1)}}</span>
                    <span>{{obj.title}}</span>
                </div>
                <div class="top">
                    {{obj.intro}}
                </div>
                <div class="time">
                    <i class="iconfont iconjijiangdaozhang"></i>
                    {{getClassTime(obj.start_time,obj.duration)}}
                </div>
                <div class="btn-box">
                    <div class="btn hover" @click="judgeTodo(obj.status)">
                        {{judgeStatusShow(obj.status,2)}}
                    </div>
                    <div class="btn link hover" @click="shareLink()">
                       查看链接
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="pre">
        <div class="content">
            <div class="pre-btn">详情</div>
        </div>
    </div>
    <div class="details-box">
        <div class="content" v-html="obj.details"></div>
    </div>
   </div>

   <share-link v-if="linkShow"
    :url="linkObj.url"
    @closeShareLink="linkShow=false"
   ></share-link>
   <h-footer></h-footer>
</div>
</template>
<script>
import Header from '../components/Header'
import Footer from '../components/Footer'
import ShareLink from '../components/ShareLink'
export default {
    name:'ClassInfo',
    data(){
        return{
            id:'',
            obj:{},

            linkShow:false,
            linkObj:{
                url:'',
                secret:''
            },
        }
    },
    components:{
        'h-header':Header,
        'h-footer':Footer,
        'share-link':ShareLink
    },
    props: ['catchData'], // 接收父组件的方法
    created(){
        // console.log(this.$route.params.id)
        // this.id = this.$route.params.id ? this.$route.params.id : this.id
        // this.getClassInfo()
    },
    activated(){
        this.loginSuccess()
    },
    methods:{
        loginSuccess(){
            console.log('ClassInfo loginSuccess')
            if(JSON.stringify(this.$route.params) !== '{}'){
                this.id = this.$route.params.id
                localStorage.setItem('ClassInfo',this.id)
            }else{
                this.id = localStorage.getItem('ClassInfo')
            }
            this.getClassInfo()
        },
        showCreate(){
            this.openWindow('CreateClass',this.obj)
        },
        getClassInfo(){
            let that = this
            that.$post(that,{
                url:'getClass',
                data:{
                    id:that.id
                },
                success(data){
                    that.obj = data
                }
            })
        },
        shareLink(){
            this.linkShow = true
            this.linkObj.url = 'id='+this.obj.id+'&token='+this.obj.token
            this.linkObj.token = this.obj.token
        },
        judgeTodo(status){
            if(status < 2){
                console.log(this.obj)
                this.openWindow('ClassRoom',{'id':this.id,'title':this.obj.title,'token':this.obj.token,'duration':this.obj.duration})
            }else{
                this.openWindow('Playback',{'id':this.id,'title':this.obj.title,'token':this.obj.token})
            }
        }
    },
    computed:{
        refresh(){
            return this.$store.state.reClassInfo
        }
    },
    watch:{
        refresh(){
            this.getClassInfo()
        }
    }
}
</script>
<style scoped>
.content{
    width:1200px;
    margin:0 auto;
}
.show{
    background: #fff;
    padding-top: 20px;
    padding-bottom: 50px;
}
.show .content{
    display: flex;
}
.show .left{
    width:468px;
    height:257px;
    border-radius:10px;
    overflow: hidden;
    margin-right: 50px;
}
.show .img-default{
    width:100%;
    height: 100%;
    line-height: 257px;
    font-size: 30px;
    color: #fff;
    font-weight: bold;
    background: url('../assets/images/class.jpg') center center no-repeat;
}
.show .img-box{
    width:100%;
    height: 100%;
}
.show .img-box img{
    width:100%;
    height: 100%;
}
.show .right{
    flex:1;
    text-align: left;
}
.show .right .top{
    padding-top: 35px;
    font-size: 24px;
    color: #333;
}
.show .right .top span:nth-child(1){
    font-size: 18px;
    color: #5FBE96;
    margin-right: 20px;
}
.show .right .time{
    margin-top: 20px;
    font-size: 16px;
    color: #999;
}
.show .right .btn-box{
    display: flex;
}
.show .right .btn{
    width:200px;
    height:40px;
    line-height: 40px;
    color: #fff;
    font-size: 18px;
    text-align: center;
    background:rgba(105,195,125,1);
    border-radius:20px;
    margin-top: 40px;
    margin-right: 10px;
}
.show .right .btn.link{
    background:#fff;
    border: 1px solid rgb(153, 153, 153);
    color: #333;
}
.pre{
    height: 40px;
    background: #F5F5F5;
    padding:7px 0;
}
.pre .pre-btn{
    width:50px;
    height:25px;
    line-height: 25px;
    border-radius:5px;
    font-size: 12px;
    color: #fff;
    background: #5FBE96;
}
.details-box{
    background: #fff;
    text-align: left;
}

.page{
    position:absolute;
    width:100%;
    min-height: 100%;
    display: flex;
    flex-direction: column;
}
.main-show{
    flex:1;
    background: #fff;
    padding-bottom: 40px;
}
</style>